var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { fetcher } from "@/schema/fetcher";
const getHistories = fetcher.path("/api/histories").method("get").create();
const getArchivedHistories = fetcher.path("/api/histories/archived").method("get").create();
const getDatasets = fetcher.path("/api/datasets").method("get").create();
const undeleteHistory = fetcher.path("/api/histories/deleted/{history_id}/undelete").method("post").create();
const purgeHistory = fetcher.path("/api/histories/{history_id}").method("delete").create();
const updateDataset = fetcher.path("/api/histories/{history_id}/contents/{type}s/{id}").method("put").create();
const purgeDataset = fetcher.path("/api/histories/{history_id}/contents/{type}s/{id}").method("delete").create();
const itemSizeSummaryFields = "id,name,size,deleted,archived";
export function fetchAllHistoriesSizeSummary() {
    return __awaiter(this, void 0, void 0, function* () {
        const nonPurgedHistoriesResponse = yield getHistories({
            keys: itemSizeSummaryFields,
            q: ["deleted", "purged"],
            qv: ["None", "false"],
        });
        const nonPurgedArchivedHistories = yield getArchivedHistories({
            keys: itemSizeSummaryFields,
            q: ["purged"],
            qv: ["false"],
        });
        const allHistoriesTakingStorageResponse = [
            ...nonPurgedHistoriesResponse.data,
            ...nonPurgedArchivedHistories.data,
        ];
        return allHistoriesTakingStorageResponse;
    });
}
export function fetchHistoryContentsSizeSummary(historyId, limit = 5000) {
    return __awaiter(this, void 0, void 0, function* () {
        const response = yield getDatasets({
            history_id: historyId,
            keys: itemSizeSummaryFields,
            limit,
            order: "size-dsc",
            q: ["purged", "history_content_type"],
            qv: ["false", "dataset"],
        });
        return response.data;
    });
}
export function undeleteHistoryById(historyId) {
    return __awaiter(this, void 0, void 0, function* () {
        const response = yield undeleteHistory({ history_id: historyId });
        return response.data;
    });
}
export function purgeHistoryById(historyId) {
    return __awaiter(this, void 0, void 0, function* () {
        const response = yield purgeHistory({ history_id: historyId, purge: true });
        return response.data;
    });
}
export function undeleteDatasetById(historyId, datasetId) {
    return __awaiter(this, void 0, void 0, function* () {
        const response = yield updateDataset({ history_id: historyId, id: datasetId, type: "dataset", deleted: false });
        return response.data;
    });
}
export function purgeDatasetById(historyId, datasetId) {
    return __awaiter(this, void 0, void 0, function* () {
        const response = yield purgeDataset({ history_id: historyId, id: datasetId, type: "dataset", purge: true });
        return response.data;
    });
}
